import { render, staticRenderFns } from "./MediaGroupArchive.vue?vue&type=template&id=258960d5&"
import script from "./MediaGroupArchive.vue?vue&type=script&lang=js&"
export * from "./MediaGroupArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports